import styled from 'styled-components/macro';

import Typography from 'components/Typography/Typography';

export const TitleStyled = styled(Typography)`
  margin-top: 0.375rem;
`;

export const ErrorDetailsStyled = styled(Typography)`
  margin-top: 0.375rem;
`;
